import React from 'react';

import { RentVsBuyInput } from '../../../../../lib/utils';
import BuyingCostsInput from '../buying-costs';

const BuyingCostsInputWithAnalytics: React.FC<RentVsBuyInput> = ({
  label,
  tooltip,
  className,
  fullWidth,
}) => {
  return (
    <BuyingCostsInput
      label={label}
      tooltip={tooltip}
      className={className}
      fullWidth={fullWidth}
    />
  );
};

export default BuyingCostsInputWithAnalytics;
